// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-capi[data-v-4feef8da] {\r\n  border: 1px solid gainsboro;\r\n  width: 50px !important;\r\n  margin-right: 5px;\n}\n.riga-card[data-v-4feef8da] {\r\n  margin: 1rem 0;\r\n  padding-bottom: 0;\n}\n.riga-card .container[data-v-4feef8da] {\r\n  padding: 1rem 0 0 0;\r\n  margin-left: 2.4rem;\n}\n.riga-card h3[data-v-4feef8da] {\r\n  margin-left: 2.4rem;\n}\n.no-risultati-alert[data-v-4feef8da] {\r\n  margin-top: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
